/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

export const headerMiniCartItemSX: SxProps = {
	color: 'grey.500',
	p: '15px 20px',
	fontWeight: OpenSansFontWeights.light,
};

export const headerMiniCartLabelItemSX: SxProps = {
	fontWeight: '600',
	color: 'grey.500',
};
